import { Container } from "@fluidattacks/design";
import { keyframes, styled } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const SkeletonBar = styled.div<{ width: string }>`
  height: 14px;
  width: ${({ width }): string => width};
  margin-bottom: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f3f3f3 25%, #e0e0e0 50%, #f3f3f3 75%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.2s infinite linear;
`;

const SkeletonLoader = (): JSX.Element => (
  <Container display={"flex"} flexDirection={"column"} gap={0}>
    <SkeletonBar width={"90%"} />
    <SkeletonBar width={"70%"} />
    <SkeletonBar style={{ marginBottom: 0 }} width={"50%"} />
  </Container>
);

export { SkeletonLoader };
